<template>
<footer class="uk-section uk-background-dark uk-section-medium uk-padding-remove-bottom uk-light">
    <div class="uk-container">
        <div class="uk-child-width-auto@m uk-flex-between uk-grid uk-text-left@m uk-text-center" uk-grid>
            <div class="uk-grid uk-width-3-5@m" uk-grid>
                <div class="uk-width-1-2@s">
                    <h4>Quick Links</h4>
                    <ul class="uk-nav">
                        <router-link to="/about/founders-message" tag="li"><a>About Us</a></router-link>
                        <router-link to="/programs/projects" tag="li"><a>Featured Projects</a></router-link>
                        <router-link to="/programs/projects/start" tag="li"><a>Start a Project</a></router-link>
                        <router-link to="/museum" tag="li"><a>Museum</a></router-link>
                        <router-link to="/programs/lmc-fellowship" tag="li"><a>LMC Fellows Program</a></router-link>
                    </ul>
                </div>
                <hr class="uk-hidden@s" />
                <div class="uk-width-1-2@s">
                    <h4>Contact Us</h4>
                    <p>
                        <b>P:</b> 620-223-1312<br/>
                        <b>E:</b> info@lowellmilkencenter.org
                    </p>
                    <p>Lowell Milken Center for Unsung Heroes<br/>
                        1 South Main<br/>
                        Fort Scott, KS 66701
                    </p>
                </div>
            </div>

            <hr class="uk-hidden@m" />

            <div class="uk-width-2-5@m uk-text-right@m">
                <h4>Follow Us</h4>
                <FollowLinks class="uk-grid uk-child-width-auto uk-display-inline-block" uk-grid />

                <h4>Support LMC</h4>
                <router-link to="/donate" class="uk-button uk-button-large theme-button button-green">Donate</router-link>
            </div>
        </div>

        <hr class="uk-margin-remove-bottom uk-margin-large-top">

        <div class="uk-margin-top uk-margin-bottom">
            <div class="uk-child-width-auto@m uk-flex-between uk-grid" uk-grid>
                <div class="uk-first-column">
                    <div class="uk-text-left@m uk-text-center">
                        <router-link class="uk-logo uk-logo-footer" to="/"></router-link>
                    </div>
                </div>
                <div>
                    <div class="uk-last-column uk-text-right@m uk-text-center uk-margin-top">
                        <p>Copyright {{currentYear}}, Lowell Milken Center for Unsung Heroes</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
</template>

<script>
export default {
    computed: {
        currentYear() {
            return (new Date()).getFullYear()
        }
    }
}
</script>
